import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "products" }
const _hoisted_2 = {
  ref: "file_input",
  type: "file",
  class: "file",
  accept: ".csv"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _hoisted_2, null, 512 /* NEED_PATCH */),
    _createVNode($setup["TasksRunner"], {
      "runner-id": "adm_import_products_csv",
      caption: "Import Install Base catalog",
      runner: (tasks) => $options.runImportProductsCsv(tasks)
    }, null, 8 /* PROPS */, ["runner"])
  ]))
}